<template>
  <!-- odist-hide-cost: 직원계정 역할 옵션 '매입단가·원가 보기' 가 꺼지면 .cost-col 요소를 숨긴다 (utils/odistPerm) -->
  <div class="app-layout" :class="{ 'pos_body': flutterWindows, 'odist-hide-cost': !$odistOption('show_purchase_price') }" @wheel="otherWheel">
    <!-- Navigation Drawer -->
    <NavDrawer
      v-if="!hide_drawer"
      v-model="drawer"
      :width="280"
    >
      <template #header>
        <div class="drawer-header-content">
          <!-- MYSHOP 관리자는 새 로고('.do' 없이 myshop, 흰 글자 + 분홍 가방 — 보라 머리 바탕 위) -->
          <img v-if="menu_type === 10" class="drawer-brand-logo" src="/img/logo_myshop_white.png" alt="myshop" width="483" height="144" />
          <template v-else>
            <div class="drawer-logo">
              <i class="fa fa-store"></i>
            </div>
            <div class="drawer-title-area">
              <h2 class="drawer-title">QRO</h2>
              <p class="drawer-subtitle">관리자</p>
            </div>
          </template>
        </div>
      </template>

      <!-- Menu Type 2: Master Settings -->
      <NavList v-if="menu_type === 2">
          <NavListSubheader title="미미라인" />

          <NavListGroup v-if="isSubuserGroupAllowed(['mimiline_categories', 'product_list1', 'product_list2', 'product_add', 'vendor_management'])" title="기준 정보 관리">
            <NavListItem v-if="isSubuserAllowed('vendor_management')" title="거래처 관리" :active="isActive('/admin/erp/vendor_management')" @click="nav({path:'/admin/erp/vendor_management'})" />
            <NavListItem v-if="isSubuserAllowed('mimiline_categories')" title="품목 분류 관리" :active="isActive('/admin/erp/mimiline_categories')" @click="nav({path:'/admin/erp/mimiline_categories'})" />
            <NavListItem v-if="isSubuserAllowed('product_list1')" title="품목 관리1" :active="isActive('/admin/erp/product_list1')" @click="nav({path:'/admin/erp/product_list1'})" />
            <NavListItem v-if="isSubuserAllowed('product_list2')" title="품목 관리2" :active="isActive('/admin/erp/product_list2')" @click="nav({path:'/admin/erp/product_list2'})" />
            <NavListItem v-if="isSubuserAllowed('product_add')" title="품목 등록" :active="isActive('/admin/erp/product_add')" @click="nav({path:'/admin/erp/product_add'})" />
          </NavListGroup>
          <NavListGroup v-if="isSubuserGroupAllowed(['mimibax_order', 'order_list2'])" title="구매 관리">
            <NavListItem v-if="isSubuserAllowed('mimibax_order')" title="신규 발주" :active="isActive('/admin/erp/mimibax_order')" @click="nav({path:'/admin/erp/mimibax_order'})" />
            <NavListItem v-if="isSubuserAllowed('order_list2')" title="발주 현황" :active="isActive('/admin/erp/order_list2')" @click="nav({path:'/admin/erp/order_list2'})" />
            <NavListItem v-show="false" title="발주 상세" :active="isActive('/admin/erp/order_detail')" @click="nav({path:'/admin/erp/order_detail'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['/erp/inventory-counts', '/erp/warehouses', '/erp/warehouse-boxes'])" title="재고 관리">
            <NavListItem v-if="isSubuserAllowed('/erp/inventory-counts')" title="재고 실사" :active="isActive('/erp/inventory-counts')" @click="nav({path:'/erp/inventory-counts'})" />
            <NavListItem v-if="isSubuserAllowed('/erp/warehouses')" title="창고 설정" :active="isActive('/erp/warehouses')" @click="nav({path:'/erp/warehouses'})" />
            <NavListItem v-if="isSubuserAllowed('/erp/warehouse-boxes')" title="창고 관리" :active="isActive('/erp/warehouse-boxes')" @click="nav({path:'/erp/warehouse-boxes'})" />
          </NavListGroup>

          <NavListSubheader title="기존" />

          <NavListGroup v-if="isSubuserGroupAllowed(['monthly_item_dd', 'monthly_item_report'])" title="재고 관리2">
            <NavListItem v-if="isSubuserAllowed('monthly_item_dd')" title="월별 실사" :active="isActive('/admin/erp/monthly_item_dd')" @click="nav({path:'/admin/erp/monthly_item_dd'})" />
            <NavListItem v-if="isSubuserAllowed('monthly_item_report')" title="원수불 현황" :active="isActive('/admin/erp/monthly_item_report')" @click="nav({path:'/admin/erp/monthly_item_report'})" />
          </NavListGroup>

          <NavListGroup v-if="(agency || canShowMasterMenu) && isSubuserGroupAllowed(['master'])" title="마스터 설정 관리">
            <NavListItem v-if="isSubuserAllowed('master')" title="매장 관리" :active="isActive('/admin/erp/master')" @click="nav({path:'/admin/erp/master'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['/admin/sales_report/detail_report', '/admin/sales_report/region_report', '/admin/sales_report/menu_report', '/admin/sales_report/menu_type_report', '/admin/sales_report/menu_payment_report', '/admin/sales_report/timing_report', '/admin/sales_report/daily_report', '/admin/sales_report/daily_completion_report', '/admin/sales_report/guest_sales_report', '/admin/sales_report/payment_sales_report', '/admin/sales_report/discount_detail_report', '/admin/sales_report/payment_detail_report', '/admin/sales_report/event_coupon_report', '/admin/sales_report/event_coupon_detail_report'])" title="판매 리포트">
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/detail_report')" title="영수증별 매출 상세" :active="isActive('/admin/sales_report/detail_report')" @click="nav({path:'/admin/sales_report/detail_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/region_report')" title="지역/업종별 매출 현황" :active="isActive('/admin/sales_report/region_report')" @click="nav({path:'/admin/sales_report/region_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/menu_report')" title="메뉴/시간별 매출 현황" :active="isActive('/admin/sales_report/menu_report')" @click="nav({path:'/admin/sales_report/menu_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/menu_type_report')" title="메뉴군별 매출 현황" :active="isActive('/admin/sales_report/menu_type_report')" @click="nav({path:'/admin/sales_report/menu_type_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/menu_payment_report')" title="메뉴/결제형태별 매출 현황" :active="isActive('/admin/sales_report/menu_payment_report')" @click="nav({path:'/admin/sales_report/menu_payment_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/timing_report')" title="시간대별 매출 현황" :active="isActive('/admin/sales_report/timing_report')" @click="nav({path:'/admin/sales_report/timing_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/daily_report')" title="일자별 매출 현황" :active="isActive('/admin/sales_report/daily_report')" @click="nav({path:'/admin/sales_report/daily_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/daily_completion_report')" title="일일 정산 리포트" :active="isActive('/admin/sales_report/daily_completion_report')" @click="nav({path:'/admin/sales_report/daily_completion_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/guest_sales_report')" title="객층별 매출 현황" :active="isActive('/admin/sales_report/guest_sales_report')" @click="nav({path:'/admin/sales_report/guest_sales_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/payment_sales_report')" title="결제 형태별 매출 현황" :active="isActive('/admin/sales_report/payment_sales_report')" @click="nav({path:'/admin/sales_report/payment_sales_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/discount_detail_report')" title="할인 세부 내역" :active="isActive('/admin/sales_report/discount_detail_report')" @click="nav({path:'/admin/sales_report/discount_detail_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/payment_detail_report')" title="결제 세부 내역" :active="isActive('/admin/sales_report/payment_detail_report')" @click="nav({path:'/admin/sales_report/payment_detail_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/event_coupon_report')" title="이벤트 쿠폰 집계 현황" :active="isActive('/admin/sales_report/event_coupon_report')" @click="nav({path:'/admin/sales_report/event_coupon_report'})" />
            <NavListItem v-if="isSubuserAllowed('/admin/sales_report/event_coupon_detail_report')" title="이벤트 쿠폰 세부 현황" :active="isActive('/admin/sales_report/event_coupon_detail_report')" @click="nav({path:'/admin/sales_report/event_coupon_detail_report'})" />
          </NavListGroup>

          <NavListGroup v-if="agency && isSubuserGroupAllowed(['vendor_list', 'item_list', 'category_list'])" title="기본 설정 관리">
            <NavListItem v-if="isSubuserAllowed('vendor_list')" title="거래처 관리" :active="isActive('/admin/erp/vendor_list')" @click="nav({path:'/admin/erp/vendor_list'})" />
            <NavListItem v-if="isSubuserAllowed('item_list')" title="발주 품목 관리" :active="isActive(itemListPath)" @click="nav({path:itemListPath})" />
            <NavListItem v-if="isSubuserAllowed('category_list')" title="카테고리 관리" :active="isActive('/admin/erp/category_list')" @click="nav({path:'/admin/erp/category_list'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['monthly_completion', 'monthly_completion_report'])" title="재고 관리">
            <NavListItem v-if="isSubuserAllowed('monthly_completion')" title="월 마감 관리" :active="isActive('/admin/erp/monthly_completion', {master:true})" @click="nav({path:'/admin/erp/monthly_completion',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('monthly_completion_report')" title="원수불 현황" :active="isActive('/admin/erp/monthly_completion_report', {master:true})" @click="nav({path:'/admin/erp/monthly_completion_report',query:{master:true}})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['confirm_order_midas'])" title="입고">
            <NavListItem v-if="isSubuserAllowed('confirm_order_midas')" title="MIDAS 입고 확인" :active="isActive('/admin/erp/confirm_order_midas')" @click="nav({path:'/admin/erp/confirm_order_midas'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['order', 'order_list', 'storing', 'item_detail_report', 'notification_log'])" title="구매 관리">
            <NavListItem v-if="isSubuserAllowed('order')" title="신규 발주" :active="isActive('/admin/erp/order')" @click="nav({path:'/admin/erp/order'})" />
            <NavListItem v-if="isSubuserAllowed('order_list')" title="발주 현황" :active="isActive('/admin/erp/order_list')" @click="nav({path:'/admin/erp/order_list'})" />
            <NavListItem v-if="isSubuserAllowed('order_list')" title="발주 승인" :active="isActive('/admin/erp/order_list', {master:true})" @click="nav({path:'/admin/erp/order_list',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('storing')" title="입고 확인" :active="isActive('/admin/erp/storing', {master:true})" @click="nav({path:'/admin/erp/storing',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('item_detail_report')" title="조회 유형별 발주현황" :active="isActive('/admin/erp/item_detail_report', {master:true})" @click="nav({path:'/admin/erp/item_detail_report',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('notification_log')" title="발주 알림 내역" :active="isActive('/admin/erp/notification_log', {master:true})" @click="nav({path:'/admin/erp/notification_log',query:{master:true}})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['master_order_list', 'purchase_item_detail_report', 'purchase_report1', 'purchase_report2'])" title="매입 관리">
            <NavListItem v-if="isSubuserAllowed('master_order_list')" title="매입 확정" :active="isActive('/admin/erp/master_order_list', {master:true})" @click="nav({path:'/admin/erp/master_order_list',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('purchase_item_detail_report')" title="조회 유형별 매입현황" :active="isActive('/admin/erp/purchase_item_detail_report', {master:true})" @click="nav({path:'/admin/erp/purchase_item_detail_report',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('purchase_report1')" title="거래처별 매입 집계" :active="isActive('/admin/erp/purchase_report1', {master:true})" @click="nav({path:'/admin/erp/purchase_report1',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('purchase_report2')" title="매장별 매입 집계" :active="isActive('/admin/erp/purchase_report2', {master:true})" @click="nav({path:'/admin/erp/purchase_report2',query:{master:true}})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['giftcard_list'])" title="상품권 관리">
            <NavListItem v-if="isSubuserAllowed('giftcard_list')" title="상품권 관리" :active="isActive('/admin/erp/giftcard_list', {master:true})" @click="nav({path:'/admin/erp/giftcard_list',query:{master:true}})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['settlement_list_master', 'settlement_list'])" title="정산 관리">
            <NavListItem v-if="isSubuserAllowed('settlement_list_master')" title="정산 관리 마스터" :active="isActive('/admin/erp/settlement_list_master', {master:true})" @click="nav({path:'/admin/erp/settlement_list_master',query:{master:true}})" />
            <NavListItem v-if="isSubuserAllowed('settlement_list')" title="정산 관리" :active="isActive('/admin/erp/settlement_list')" @click="nav({path:'/admin/erp/settlement_list'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['sale_product_list', 'promotion_product_list', 'set_product_list'])" title="판매 관리">
            <NavListItem v-if="isSubuserAllowed('sale_product_list')" title="할인 캠페인 관리" :active="isActive('/admin/erp/sale_product_list')" @click="nav({path:'/admin/erp/sale_product_list'})" />
            <NavListItem v-if="isSubuserAllowed('promotion_product_list')" title="프로모션 캠페인 관리" :active="isActive('/admin/erp/promotion_product_list')" @click="nav({path:'/admin/erp/promotion_product_list'})" />
            <NavListItem v-if="isSubuserAllowed('set_product_list')" title="세트 상품 관리" :active="isActive('/admin/erp/set_product_list')" @click="nav({path:'/admin/erp/set_product_list'})" />
          </NavListGroup>

          <NavListGroup v-if="isSubuserGroupAllowed(['sub-user'])" title="계정 관리">
            <NavListItem v-if="isSubuserAllowed('sub-user')" title="서브계정 관리" :active="isActive('/admin/erp/sub-user')" @click="nav({path:'/admin/erp/sub-user'})" />
          </NavListGroup>

          <NavListGroup title="기타">
            <NavListItem title="로그아웃" @click="logout" />
          </NavListGroup>

      </NavList>

      <!-- Menu Type 3: Sales Report -->
      <NavList v-else-if="menu_type === 3">
        <NavListSubheader title="판매 리포트" />
        <NavListItem title="영수증별 매출 상세" :active="isActive('/admin/sales_report/detail_report')" @click="nav({path:'/admin/sales_report/detail_report'})" />
        <NavListItem title="지역/업종별 매출 현황" :active="isActive('/admin/sales_report/region_report')" @click="nav({path:'/admin/sales_report/region_report'})" />
        <NavListItem title="메뉴/시간별 매출 현황" :active="isActive('/admin/sales_report/menu_report')" @click="nav({path:'/admin/sales_report/menu_report'})" />
        <NavListItem title="메뉴군별 매출 현황" :active="isActive('/admin/sales_report/menu_type_report')" @click="nav({path:'/admin/sales_report/menu_type_report'})" />
        <NavListItem title="메뉴/결제형태별 매출 현황" :active="isActive('/admin/sales_report/menu_payment_report')" @click="nav({path:'/admin/sales_report/menu_payment_report'})" />
        <NavListItem title="시간대별 매출 현황" :active="isActive('/admin/sales_report/timing_report')" @click="nav({path:'/admin/sales_report/timing_report'})" />
        <NavListItem title="일자별 매출 현황" :active="isActive('/admin/sales_report/daily_report')" @click="nav({path:'/admin/sales_report/daily_report'})" />
        <NavListItem title="일일 정산 리포트" :active="isActive('/admin/sales_report/daily_completion_report')" @click="nav({path:'/admin/sales_report/daily_completion_report'})" />
        <NavListItem title="객층별 매출 현황" :active="isActive('/admin/sales_report/guest_sales_report')" @click="nav({path:'/admin/sales_report/guest_sales_report'})" />
        <NavListItem title="결제 형태별 매출 현황" :active="isActive('/admin/sales_report/payment_sales_report')" @click="nav({path:'/admin/sales_report/payment_sales_report'})" />
        <NavListItem title="할인 세부 내역" :active="isActive('/admin/sales_report/discount_detail_report')" @click="nav({path:'/admin/sales_report/discount_detail_report'})" />
        <NavListItem title="결제 세부 내역" :active="isActive('/admin/sales_report/payment_detail_report')" @click="nav({path:'/admin/sales_report/payment_detail_report'})" />
        <NavListItem title="이벤트 쿠폰 집계 현황" :active="isActive('/admin/sales_report/event_coupon_report')" @click="nav({path:'/admin/sales_report/event_coupon_report'})" />
        <NavListItem title="이벤트 쿠폰 세부 현황" :active="isActive('/admin/sales_report/event_coupon_detail_report')" @click="nav({path:'/admin/sales_report/event_coupon_detail_report'})" />

        <NavListGroup title="판매 상세 리포트2">
          <NavListItem title="가맹점별 매출" :active="isActive('/admin/sales_report/branch_sales')" @click="nav({path:'/admin/sales_report/branch_sales'})" />
          <NavListItem title="가맹점별 매출2" :active="isActive('/admin/sales_report/branch_sales2')" @click="nav({path:'/admin/sales_report/branch_sales2'})" />
          <NavListItem title="연간 매출" :active="isActive('/admin/sales_report/yearly_sales')" @click="nav({path:'/admin/sales_report/yearly_sales'})" />
          <NavListItem title="월간 매출" :active="isActive('/admin/sales_report/monthly_sales')" @click="nav({path:'/admin/sales_report/monthly_sales'})" />
          <NavListItem title="기간별 매출" :active="isActive('/admin/sales_report/period_sales')" @click="nav({path:'/admin/sales_report/period_sales'})" />
          <NavListItem title="유저 리스트" :active="isActive('/admin/sales_report/user_list')" @click="nav({path:'/admin/sales_report/user_list'})" />
          <NavListItem title="마케팅" :active="isActive('/admin/sales_report/marketing')" @click="nav({path:'/admin/sales_report/marketing'})" />
          <NavListItem title="시간별 매출" :active="isActive('/admin/sales_report/hourly_sales')" @click="nav({path:'/admin/sales_report/hourly_sales'})" />
          <NavListItem title="상품별 결제" :active="isActive('/admin/sales_report/sales_by_product')" @click="nav({path:'/admin/sales_report/sales_by_product'})" />
          <NavListItem title="일간 매출" :active="isActive('/admin/sales_report/daily_sales')" @click="nav({path:'/admin/sales_report/daily_sales'})" />
          <NavListItem title="장부 결제" :active="isActive('/admin/sales_report/postpaid')" @click="nav({path:'/admin/sales_report/postpaid'})" />
        </NavListGroup>
      </NavList>

      <!-- Menu Type 5: Rider User Orders -->
      <NavList v-else-if="menu_type === 5">
        <NavListSubheader title="주문 관리" />
        <NavListItem title="주문 관리" :active="isActive('/admin/rider-user/orders')" @click="nav({path:'/admin/rider-user/orders'})" />
      </NavList>

      <!-- Menu Type 4: Riders -->
      <NavList v-else-if="menu_type === 4">
        <NavListSubheader title="라이더 관리" />
        <NavListItem title="라이더 관리" :active="isActive('/admin/riders/members')" @click="nav({path:'/admin/riders/members'})" />
        <NavListItem title="라이더 현황" :active="isActive('/admin/riders/map')" @click="nav({path:'/admin/riders/map'})" />

        

        <NavListSubheader title="상점 관리" />
        <NavListItem title="상점 관리" :active="isActive('/admin/riders/mshops')" @click="nav({path:'/admin/riders/mshops'})" />

        

        <NavListSubheader title="주문 관리" />
        <NavListItem title="주문 관리" :active="isActive('/admin/riders/orders')" @click="nav({path:'/admin/riders/orders'})" />
      </NavList>

      <!-- Menu Type 6: ODIST -->
      <NavList v-else-if="menu_type === 6">
          <!-- 메뉴 정본 = src/config/odist-menus.js (역할 편집기·라우터 가드와 공유).
               마스터/매장 분기와 직원계정 권한 필터는 odistMenuGroups 에서 한다. -->
          <template v-for="g in odistMenuGroups" :key="g.key">
            <NavListGroup :title="g.title">
              <NavListItem v-for="it in g.items" :key="it.key" :title="it.title" :active="isActive(it.path)" @click="nav({path: it.path})" />
            </NavListGroup>
          </template>

          <!-- 마스터 본인만: 직원 계정·역할 관리 (서브계정에겐 안 보이고 가드도 막는다) -->
          <NavListGroup v-if="agency && !is_subuser" title="직원 계정 관리">
            <NavListItem title="직원 계정 관리" :active="isActive('/admin/odist/sub_account')" @click="nav({path:'/admin/odist/sub_account'})" />
            <NavListItem title="역할(권한) 관리" :active="isActive('/admin/odist/role_management')" @click="nav({path:'/admin/odist/role_management'})" />
          </NavListGroup>

          <NavListGroup title="기타">
            <NavListItem title="로그아웃" @click="logout" />
          </NavListGroup>
      </NavList>

      <!-- Menu Type 10: MYSHOP 관리자 (서브유저 접근 불가) -->
      <NavList v-else-if="menu_type === 10 && !is_subuser">
        <NavListSubheader title="대시보드" />
        <NavListItem title="홈" :active="isActive('/myshop')" @click="nav({path:'/myshop'})" />
        <NavListItem title="내 마이샵 바로가기" icon="fa fa-external-link-alt" @click="openMyshop" />
        <NavListItem title="마이샵 공지사항" :active="isActive('/myshop/notice/list')" @click="nav({path:'/myshop/notice/list'})" />


        <NavListSubheader title="상품 관리" />
        <NavListItem title="상품 목록" :active="isActive('/myshop/product/list')" @click="nav({path:'/myshop/product/list'})" />
        <NavListItem title="상품 등록" :active="isActive('/myshop/product/create')" @click="nav({path:'/myshop/product/create'})" />
        <NavListItem title="카테고리 관리" :active="isActive('/myshop/product/category-list')" @click="nav({path:'/myshop/product/category-list'})" />
        <NavListItem title="도매매 API" :active="isActive('/myshop/product/domae_api')" @click="nav({path:'/myshop/product/domae_api'})" />


        <NavListSubheader title="주문 관리" />
        <NavListItem title="전체 주문 관리" :active="isActive('/myshop/order/list')" @click="nav({path:'/myshop/order/list'})" />
        <NavListItem title="배송 필요" :badge="orderSummary.ready || null" badge-class="badge-warning" :active="isActive('/myshop/order/list', {type:'ready'})" @click="nav({path:'/myshop/order/list', query:{type:'ready'}})" />
        <NavListItem title="교환/환불 요청" :badge="orderSummary.refund || null" badge-class="badge-danger" :active="isActive('/myshop/order/list', {type:'refund'})" @click="nav({path:'/myshop/order/list', query:{type:'refund'}})" />
        <NavListItem title="정산 관리" :active="isActive('/myshop/order/finalized')" @click="nav({path:'/myshop/order/finalized'})" />
        <NavListItem title="부가세 신고 내역" :active="isActive('/myshop/order/vat')" @click="nav({path:'/myshop/order/vat'})" />
        <NavListItem title="상품별 주문현황" :active="isActive('/myshop/order/product_summary')" @click="nav({path:'/myshop/order/product_summary'})" />

        <NavListSubheader title="회원 관리" />
        <NavListItem title="회원 목록" :active="isActive('/myshop/member/list')" @click="nav({path:'/myshop/member/list'})" />


        <NavListSubheader title="쿠폰/포인트" />
        <NavListItem title="쿠폰 목록" :active="isActive('/myshop/coupon/list')" @click="nav({path:'/myshop/coupon/list'})" />
        <NavListItem title="쿠폰 생성" :active="isActive('/myshop/coupon/create')" @click="nav({path:'/myshop/coupon/create'})" />

        <!-- 파트너 판매 — Java /api/shopadm/partner/program 을 못 읽으면(API 배포 전 등) 묶음째 숨긴다 -->
        <template v-if="myshopFeat.partner">
          <NavListSubheader title="파트너 판매" />
          <NavListItem title="파트너 판매 설정" :active="isActive('/myshop/partner/setting')" @click="nav({path:'/myshop/partner/setting'})" />
          <NavListItem title="파트너" :badge="myshopFeat.partnerPending || null" badge-class="badge-warning" :active="isActive('/myshop/partner/list')" @click="nav({path:'/myshop/partner/list'})" />
          <NavListItem title="상품별 요율" :active="isActive('/myshop/partner/products')" @click="nav({path:'/myshop/partner/products'})" />
          <NavListItem title="정산 장부" :active="isActive('/myshop/partner/ledger')" @click="nav({path:'/myshop/partner/ledger'})" />
        </template>

        <!-- SNS 판매 자동화(인스타) — core-api 인스타 상태가 켜짐(enabled)·시범 샵(allowed)일 때만. 유튜브는 유튜브 상태로 따로 -->
        <template v-if="myshopFeat.social || myshopFeat.youtube">
          <NavListSubheader title="SNS 판매 자동화" />
          <template v-if="myshopFeat.social">
            <NavListItem title="개요" :active="isActive('/myshop/social')" @click="nav({path:'/myshop/social'})" />
            <NavListItem title="자동화" :active="isActive('/myshop/social/rules')" @click="nav({path:'/myshop/social/rules'})" />
            <NavListItem title="인스타 게시물" :active="isActive('/myshop/social/posts')" @click="nav({path:'/myshop/social/posts'})" />
            <NavListItem title="인스타 공구" :active="isActive('/myshop/social/groupbuy')" @click="nav({path:'/myshop/social/groupbuy'})" />
            <NavListItem title="콘텐츠 성과" :active="isActive('/myshop/social/content')" @click="nav({path:'/myshop/social/content'})" />
            <NavListItem title="발송 기록" :active="isActive('/myshop/social/deliveries')" @click="nav({path:'/myshop/social/deliveries'})" />
          </template>
          <NavListItem title="영상 게시" :active="isActive('/myshop/social/publish')" @click="nav({path:'/myshop/social/publish'})" />
          <NavListItem v-if="myshopFeat.social" title="인스타그램 연결" :active="isActive('/myshop/instagram')" @click="nav({path:'/myshop/instagram'})" />
          <NavListItem v-if="myshopFeat.youtube" title="유튜브 연결" :active="isActive('/myshop/youtube')" @click="nav({path:'/myshop/youtube'})" />
        </template>


        <NavListSubheader title="디자인" />
        <NavListItem title="마이샵 디자인 설정" :active="isActive('/myshop/design/skin')" @click="nav({path:'/myshop/design/skin'})" />
        <NavListItem title="메인 배너 설정" :active="isActive('/myshop/design/kv')" @click="nav({path:'/myshop/design/kv'})" />
        <NavListItem title="메인 페이지 설정" :active="isActive('/myshop/design/mainpage')" @click="nav({path:'/myshop/design/mainpage'})" />
        <NavListItem title="팝업 관리" :active="isActive('/myshop/popup')" @click="nav({path:'/myshop/popup'})" />


        <NavListSubheader title="컨텐츠 관리" />
        <NavListItem title="(공지) 컨텐츠 페이지" :active="isActive('/myshop/product/contents-list')" @click="nav({path:'/myshop/product/contents-list'})" />
        <NavListItem title="판매자 글 번역(글로벌 판매)" :active="isActive('/myshop/i18n')" @click="nav({path:'/myshop/i18n'})" />


        <NavListSubheader title="Q&A/리뷰" />
        <NavListItem title="Q&A 관리" :active="isActive('/myshop/qna/list')" @click="nav({path:'/myshop/qna/list'})" />
        <NavListItem title="리뷰 관리" :active="isActive('/myshop/review/list')" @click="nav({path:'/myshop/review/list'})" />

        <NavListSubheader title="성과 분석" />
        <NavListItem title="성과 리포트" :active="isActive('/myshop/performance')" @click="nav({path:'/myshop/performance'})" />

        <NavListSubheader title="설정" />
        <NavListItem title="샵 설정" :active="isActive('/myshop/setting')" @click="nav({path:'/myshop/setting'})" />
        <NavListItem title="사업자 정보" :active="isActive('/myshop/setting/corp')" @click="nav({path:'/myshop/setting/corp'})" />
        <NavListItem title="배송 설정" :active="isActive('/myshop/product/delivery')" @click="nav({path:'/myshop/product/delivery'})" />
        <NavListItem title="환불 규정" :active="isActive('/myshop/setting/refund_rules')" @click="nav({path:'/myshop/setting/refund_rules'})" />
        <NavListItem title="적립금 관리" :active="isActive('/myshop/product/point')" @click="nav({path:'/myshop/product/point'})" />
        <NavListItem title="리뷰 적립금" :active="isActive('/myshop/product/review-point')" @click="nav({path:'/myshop/product/review-point'})" />
        <NavListItem title="커스텀 스크립트" :active="isActive('/myshop/setting/script')" @click="nav({path:'/myshop/setting/script'})" />

        <NavListSubheader title="기타" />
        <NavListItem title="로그아웃" @click="logout" />

        <!-- 마스터 관리 메뉴 (admin 또는 uid 67이고 허용된 IP인 경우에만 표시) -->
        <template v-if="canShowMasterMenu">
          <NavListSubheader title="MYSHOP 마스터 관리" />
          <NavListItem title="사업자 확인" :active="isActive('/admin/master/confirm_user_corp')" @click="nav({path:'/admin/master/confirm_user_corp'})" />
          <NavListItem title="정보 변경 요청" :active="isActive('/admin/master/shop_info_requests')" @click="nav({path:'/admin/master/shop_info_requests'})" />
          <NavListItem title="마이샵 확인" :active="isActive('/admin/master/confirm_myshop')" @click="nav({path:'/admin/master/confirm_myshop'})" />
          <NavListItem title="마이샵 목록" :active="isActive('/admin/master/mshop_list')" @click="nav({path:'/admin/master/mshop_list'})" />
          <NavListItem title="회원 목록" :active="isActive('/admin/master/member_list')" @click="nav({path:'/admin/master/member_list'})" />
          <NavListItem title="초대 이메일 관리" :active="isActive('/admin/master/invite_email')" @click="nav({path:'/admin/master/invite_email'})" />

          <NavListSubheader title="MYSHOP 정산/환불 관리" />
          <NavListItem title="정산 확정 관리" :active="isActive('/admin/master/order_finalized')" @click="nav({path:'/admin/master/order_finalized'})" />
          <NavListItem title="통합 환불" :active="isActive('/admin/master/unified_refund')" @click="nav({path:'/admin/master/unified_refund'})" />
          <NavListItem title="정산완료 주문 차감" :active="isActive('/admin/master/settled_deduct')" @click="nav({path:'/admin/master/settled_deduct'})" />
          <!-- 통합 환불로 대체하여 숨김 (라우트는 유지)
          <NavListItem title="예외 환불 관리" :active="isActive('/admin/master/exceptional_refund')" @click="nav({path:'/admin/master/exceptional_refund'})" />
          <NavListItem title="부분 환불 관리" :active="isActive('/admin/master/partial_refund')" @click="nav({path:'/admin/master/partial_refund'})" />
          -->

          <NavListItem title="정산금액 조정" :active="isActive('/admin/master/exceptional_adjustment')" @click="nav({path:'/admin/master/exceptional_adjustment'})" />
          <NavListItem title="현금환불 확인" :active="isActive('/admin/master/confirm_refund_cash')" @click="nav({path:'/admin/master/confirm_refund_cash'})" />

          <NavListSubheader title="관리자 메뉴" />
          <NavListItem title="사용자 목록" :active="isActive('/master-admin/musers')" @click="nav({path:'/master-admin/musers'})" />
          <NavListItem title="상점 목록" :active="isActive('/master-admin/mshops')" @click="nav({path:'/master-admin/mshops'})" />
          <!-- 사업자 신청 관리 (사용 중지) -->
          <!-- <NavListItem title="사업자 신청 관리" :active="isActive('/master-admin/billing/seller-embed-list')" @click="nav({path:'/master-admin/billing/seller-embed-list'})" /> -->
          <!-- <NavListItem title="온라인 사업자 신청 관리" :active="isActive('/master-admin/billing/seller-embed-list2')" @click="nav({path:'/master-admin/billing/seller-embed-list2'})" /> -->
          <NavListItem title="정기요금 결제 관리" :active="isActive('/master-admin/billing/payment-embed-list')" @click="nav({path:'/master-admin/billing/payment-embed-list'})" />
          <NavListItem title="요금 결제 관리 v2" :active="isActive('/master-admin/billing/payment-list2')" @click="nav({path:'/master-admin/billing/payment-list2'})" />
          <NavListItem title="딜리버리 신청 관리" :active="isActive('/master-admin/delivery_account_mng')" @click="nav({path:'/master-admin/delivery_account_mng'})" />
          <NavListItem title="오프라인 샵 설정 관리" :active="isActive('/master-admin/offline_account_mng')" @click="nav({path:'/master-admin/offline_account_mng'})" />
          <NavListItem title="도매매 PG 관리" :active="isActive('/master-admin/billing/domaemae-pg')" @click="nav({path:'/master-admin/billing/domaemae-pg'})" />
          <NavListItem title="나이스 PG 관리" :active="isActive('/master-admin/billing/nice-pg')" @click="nav({path:'/master-admin/billing/nice-pg'})" />

          <NavListSubheader title="관리자 권한 관리" />
          <NavListItem title="관리자 권한 관리" :active="isActive('/master-admin/root/members')" @click="nav({path:'/master-admin/root/members'})" />
          <NavListItem title="관리자 접속 로그" :active="isActive('/master-admin/root/member_logs')" @click="nav({path:'/master-admin/root/member_logs'})" />
          <NavListItem title="위치정보 이용 제공 사실 확인자료" :active="isActive('/master-admin/root/geo_access_logs')" @click="nav({path:'/master-admin/root/geo_access_logs'})" />
          <NavListItem title="관리자 조회 로그" :active="isActive('/master-admin/root/access_logs')" @click="nav({path:'/master-admin/root/access_logs'})" />
        </template>
      </NavList>

      <!-- Menu Type 0: Default Menu (서브유저 접근 불가) -->
      <NavList v-if="menu_type === 0 && !is_subuser">
        <NavListSubheader title="마이샵 정보" />
        <NavListItem title="마이샵 설정" :active="isActive('/admin/myshop_info')" @click="nav({path:'/admin/myshop_info'})" />
        <NavListItem title="사업자 정보" :active="isActive('/admin/corp')" @click="nav({path:'/admin/corp'})" />
        <NavListItem title="스마트오더(배달/픽업) 설정" :active="isActive('/admin/smartorder_info')" @click="nav({path:'/admin/smartorder_info'})" />
        <NavListItem title="공지사항 관리" :active="isActive('/admin/prod/notice_list')" @click="nav({path:'/admin/prod/notice_list'})" />

        

        <NavListSubheader title="판매 리포트" />
        <NavListItem title="판매 요약 달력" :active="isActive('/admin/sales_report/summary_calendar')" @click="nav({path:'/admin/sales_report/summary_calendar'})" />
        <NavListItem title="판매 요약" :active="isActive('/admin/sales_report/summary')" @click="nav({path:'/admin/sales_report/summary'})" />
        <NavListItem title="스마트오더 상세" :active="isActive('/admin/sales_report/smartorder')" @click="nav({path:'/admin/sales_report/smartorder'})" />

        <NavListGroup title="판매 상세 리포트">
          <NavListItem title="영수증별 매출 상세" :active="isActive('/admin/sales_report/detail_report')" @click="nav({path:'/admin/sales_report/detail_report'})" />
          <NavListItem title="지역/업종별 매출 현황" :active="isActive('/admin/sales_report/region_report')" @click="nav({path:'/admin/sales_report/region_report'})" />
          <NavListItem title="메뉴/시간별 매출 현황" :active="isActive('/admin/sales_report/menu_report')" @click="nav({path:'/admin/sales_report/menu_report'})" />
          <NavListItem title="메뉴군별 매출 현황" :active="isActive('/admin/sales_report/menu_type_report')" @click="nav({path:'/admin/sales_report/menu_type_report'})" />
          <NavListItem title="메뉴/결제형태별 매출 현황" :active="isActive('/admin/sales_report/menu_payment_report')" @click="nav({path:'/admin/sales_report/menu_payment_report'})" />
          <NavListItem title="시간대별 매출 현황" :active="isActive('/admin/sales_report/timing_report')" @click="nav({path:'/admin/sales_report/timing_report'})" />
          <NavListItem title="일자별 매출 현황" :active="isActive('/admin/sales_report/daily_report')" @click="nav({path:'/admin/sales_report/daily_report'})" />
          <NavListItem title="일일 정산 리포트" :active="isActive('/admin/sales_report/daily_completion_report')" @click="nav({path:'/admin/sales_report/daily_completion_report'})" />
          <NavListItem title="객층별 매출 현황" :active="isActive('/admin/sales_report/guest_sales_report')" @click="nav({path:'/admin/sales_report/guest_sales_report'})" />
          <NavListItem title="결제 형태별 매출 현황" :active="isActive('/admin/sales_report/payment_sales_report')" @click="nav({path:'/admin/sales_report/payment_sales_report'})" />
          <NavListItem title="할인 세부 내역" :active="isActive('/admin/sales_report/discount_detail_report')" @click="nav({path:'/admin/sales_report/discount_detail_report'})" />
          <NavListItem title="결제 세부 내역" :active="isActive('/admin/sales_report/payment_detail_report')" @click="nav({path:'/admin/sales_report/payment_detail_report'})" />
          <NavListItem title="이벤트 쿠폰 집계 현황" :active="isActive('/admin/sales_report/event_coupon_report')" @click="nav({path:'/admin/sales_report/event_coupon_report'})" />
          <NavListItem title="이벤트 쿠폰 세부 현황" :active="isActive('/admin/sales_report/event_coupon_detail_report')" @click="nav({path:'/admin/sales_report/event_coupon_detail_report'})" />
        </NavListGroup>

        <NavListGroup title="판매 상세 리포트2">
          <NavListItem title="가맹점별 매출" :active="isActive('/admin/sales_report/branch_sales')" @click="nav({path:'/admin/sales_report/branch_sales'})" />
          <NavListItem title="가맹점별 매출2" :active="isActive('/admin/sales_report/branch_sales2')" @click="nav({path:'/admin/sales_report/branch_sales2'})" />
          <NavListItem title="연간 매출" :active="isActive('/admin/sales_report/yearly_sales')" @click="nav({path:'/admin/sales_report/yearly_sales'})" />
          <NavListItem title="월간 매출" :active="isActive('/admin/sales_report/monthly_sales')" @click="nav({path:'/admin/sales_report/monthly_sales'})" />
          <NavListItem title="기간별 매출" :active="isActive('/admin/sales_report/period_sales')" @click="nav({path:'/admin/sales_report/period_sales'})" />
          <NavListItem title="유저 리스트" :active="isActive('/admin/sales_report/user_list')" @click="nav({path:'/admin/sales_report/user_list'})" />
          <NavListItem title="마케팅" :active="isActive('/admin/sales_report/marketing')" @click="nav({path:'/admin/sales_report/marketing'})" />
          <NavListItem title="시간별 매출" :active="isActive('/admin/sales_report/hourly_sales')" @click="nav({path:'/admin/sales_report/hourly_sales'})" />
          <NavListItem title="상품별 결제" :active="isActive('/admin/sales_report/sales_by_product')" @click="nav({path:'/admin/sales_report/sales_by_product'})" />
          <NavListItem title="일간 매출" :active="isActive('/admin/sales_report/daily_sales')" @click="nav({path:'/admin/sales_report/daily_sales'})" />
          <NavListItem title="장부 결제" :active="isActive('/admin/sales_report/postpaid')" @click="nav({path:'/admin/sales_report/postpaid'})" />
        </NavListGroup>



        <NavListSubheader title="상품 관리" />
        <NavListItem title="오프라인 상품 관리" :active="isActive('/admin/e_prod_list')" @click="nav({path:'/admin/e_prod_list'})" />
        <NavListItem title="메뉴 상품 일괄 관리" :active="isActive('/admin/prod/offline_menu_xls')" @click="nav({path:'/admin/prod/offline_menu_xls'})" />
        <NavListItem title="바코드 상품 일괄 등록" :active="isActive('/admin/prod/offline_xls')" @click="nav({path:'/admin/prod/offline_xls'})" />

        
        <NavListSubheader title="매장 관리" />
        <NavListItem title="고객 관리" :active="isActive('/admin/manager/member_mng')" @click="nav({path:'/admin/manager/member_mng'})" />
        <NavListItem title="오프라인 기기 관리" :active="isActive('/admin/manager/kiosk')" @click="nav({path:'/admin/manager/kiosk'})" />

        <NavListSubheader title="가맹 관리" />
        <NavListItem title="창업 문의 관리" :active="isActive('/admin/store/customer_requests')" @click="nav({path:'/admin/store/customer_requests'})" />
        <NavListItem title="창업 문의 및 홈페이지 관리" @click="go_ja0" />


        <NavListSubheader title="결제 관리" />
        <NavListItem title="결제 카드 관리" :active="isActive('/admin/billing/card-list')" @click="nav({path:'/admin/billing/card-list'})" />
        <NavListItem title="결제 내역 확인" :active="isActive('/admin/billing/payment-list')" @click="nav({path:'/admin/billing/payment-list'})" />
        <NavListItem title="메시지 과금 상세" :active="isActive('/admin/billing/credit-management-list')" @click="nav({path:'/admin/billing/credit-management-list'})" />


        <NavListSubheader title="마케팅" />
        <NavListItem title="마케팅 메시지 전송" :active="isActive('/admin/marketing/msg')" @click="nav({path:'/admin/marketing/msg'})" />


        <NavListSubheader title="번역 관리" />
        <NavListItem title="컨텐츠 일괄 변역" :active="isActive('/admin/lang/update-contents')" @click="nav({path:'/admin/lang/update-contents'})" />
        <NavListItem title="AI 일괄 변역" :active="isActive('/admin/lang/ai-update-contents')" @click="nav({path:'/admin/lang/ai-update-contents'})" />

        <NavListSubheader title="디자인 관리" />
        <NavListItem title="테마 색상 설정" :active="isActive('/admin/design/set-color')" @click="nav({path:'/admin/design/set-color'})" />

        <NavListSubheader title="계정" />
        <NavListItem title="로그아웃" @click="logout" />

        <template v-if="canShowMasterMenu">

          <NavListSubheader title="관리자 메뉴" />
          <NavListItem title="사용자 목록" :active="isActive('/master-admin/musers')" @click="nav({path:'/master-admin/musers'})" />
          <NavListItem title="상점 목록" :active="isActive('/master-admin/mshops')" @click="nav({path:'/master-admin/mshops'})" />
          <!-- 사업자 신청 관리 (사용 중지) -->
          <!-- <NavListItem title="사업자 신청 관리" :active="isActive('/master-admin/billing/seller-embed-list')" @click="nav({path:'/master-admin/billing/seller-embed-list'})" /> -->
          <!-- <NavListItem title="온라인 사업자 신청 관리" :active="isActive('/master-admin/billing/seller-embed-list2')" @click="nav({path:'/master-admin/billing/seller-embed-list2'})" /> -->
          <NavListItem title="정기요금 결제 관리" :active="isActive('/master-admin/billing/payment-embed-list')" @click="nav({path:'/master-admin/billing/payment-embed-list'})" />
          <NavListItem title="요금 결제 관리 v2" :active="isActive('/master-admin/billing/payment-list2')" @click="nav({path:'/master-admin/billing/payment-list2'})" />
          <NavListItem title="딜리버리 신청 관리" :active="isActive('/master-admin/delivery_account_mng')" @click="nav({path:'/master-admin/delivery_account_mng'})" />
          <NavListItem title="오프라인 샵 설정 관리" :active="isActive('/master-admin/offline_account_mng')" @click="nav({path:'/master-admin/offline_account_mng'})" />
          <NavListItem title="도매매 PG 관리" :active="isActive('/master-admin/billing/domaemae-pg')" @click="nav({path:'/master-admin/billing/domaemae-pg'})" />
          <NavListItem title="나이스 PG 관리" :active="isActive('/master-admin/billing/nice-pg')" @click="nav({path:'/master-admin/billing/nice-pg'})" />

          <NavListSubheader title="MYSHOP 마스터 관리" />
          <NavListItem title="사업자 확인" :active="isActive('/admin/master/confirm_user_corp')" @click="nav({path:'/admin/master/confirm_user_corp'})" />
          <NavListItem title="정보 변경 요청" :active="isActive('/admin/master/shop_info_requests')" @click="nav({path:'/admin/master/shop_info_requests'})" />
          <NavListItem title="마이샵 확인" :active="isActive('/admin/master/confirm_myshop')" @click="nav({path:'/admin/master/confirm_myshop'})" />
          <NavListItem title="마이샵 목록" :active="isActive('/admin/master/mshop_list')" @click="nav({path:'/admin/master/mshop_list'})" />
          <NavListItem title="회원 목록" :active="isActive('/admin/master/member_list')" @click="nav({path:'/admin/master/member_list'})" />
          <NavListItem title="초대 이메일 관리" :active="isActive('/admin/master/invite_email')" @click="nav({path:'/admin/master/invite_email'})" />

          

          <NavListSubheader title="MYSHOP 정산/환불 관리" />
          <NavListItem title="정산 확정 관리" :active="isActive('/admin/master/order_finalized')" @click="nav({path:'/admin/master/order_finalized'})" />
          <NavListItem title="통합 환불" :active="isActive('/admin/master/unified_refund')" @click="nav({path:'/admin/master/unified_refund'})" />
          <NavListItem title="정산완료 주문 차감" :active="isActive('/admin/master/settled_deduct')" @click="nav({path:'/admin/master/settled_deduct'})" />
          <!-- 통합 환불로 대체하여 숨김 (라우트는 유지)
          <NavListItem title="예외 환불 관리" :active="isActive('/admin/master/exceptional_refund')" @click="nav({path:'/admin/master/exceptional_refund'})" />
          <NavListItem title="부분 환불 관리" :active="isActive('/admin/master/partial_refund')" @click="nav({path:'/admin/master/partial_refund'})" />
          -->

          <NavListItem title="정산금액 조정" :active="isActive('/admin/master/exceptional_adjustment')" @click="nav({path:'/admin/master/exceptional_adjustment'})" />
          <NavListItem title="현금환불 확인" :active="isActive('/admin/master/confirm_refund_cash')" @click="nav({path:'/admin/master/confirm_refund_cash'})" />



          <NavListSubheader title="관리자 권한 관리" />
          <NavListItem title="관리자 권한 관리" :active="isActive('/master-admin/root/members')" @click="nav({path:'/master-admin/root/members'})" />
          <NavListItem title="관리자 접속 로그" :active="isActive('/master-admin/root/member_logs')" @click="nav({path:'/master-admin/root/member_logs'})" />
          <NavListItem title="위치정보 이용 제공 사실 확인자료" :active="isActive('/master-admin/root/geo_access_logs')" @click="nav({path:'/master-admin/root/geo_access_logs'})" />
          <NavListItem title="관리자 조회 로그" :active="isActive('/master-admin/root/access_logs')" @click="nav({path:'/master-admin/root/access_logs'})" />
        </template>
      </NavList>
    </NavDrawer>

    <!-- App Bar -->
    <AppBar
      v-if="!hide_menu && menu"
      :title="menu_title"
      :color="color"
      @toggle-drawer="drawer = !drawer"
    >
      <template #right>
        <div v-if="showAccountSwitchArea" class="app-bar-right-area">
          <span v-if="currentAccountName" class="app-bar-account-badge">
            {{ currentAccountName }}
          </span>
          <button
            v-if="!odistSub && isSwitchedToStore"
            type="button"
            class="app-bar-master-btn"
            :disabled="accountSwitching"
            @click="backToMaster"
          >↩ 마스터 계정으로 전환</button>
          <!-- odist 직원계정: 역할 범위 안의 마스터/매장만 오간다 (core-api /subuser/odist/switch) -->
          <div v-if="odistSub && odistScopeItems.length > 1" class="app-bar-account-switch">
            <BaseAutocomplete
              v-model="selected_odist_account"
              :items="odistScopeItems"
              item-title="name"
              item-value="uid"
              placeholder="계정 전환"
              class="account-switch-select"
              :loading="accountSwitching"
              @update:modelValue="odistSwitch"
            />
          </div>
          <div v-if="!odistSub && agency && agency_sub_accounts.length > 0" class="app-bar-account-switch">
            <BaseAutocomplete
              v-model="selected_sub_account"
              :items="agency_sub_accounts"
              item-title="name"
              item-value="uid"
              placeholder="고객 계정 전환"
              class="account-switch-select"
              :loading="accountSwitching"
              @update:modelValue="chg_sub_accounts"
            />
          </div>
          <span v-else-if="uid && !agency && !canShowMasterMenu && login_data" class="app-bar-account-badge">
            {{ login_data.name || 'UID: ' + uid }}
          </span>
        </div>
      </template>
    </AppBar>

    <!-- Main Content -->
    <main class="app-main">
      <!-- 탭 틀(route.meta.shell — SNS 판매 자동화)은 안쪽 화면만 바뀌게 틀 이름을 key 로, 나머지는 주소마다 새로 -->
      <router-view :key="routeKey + '-' + ($route.meta.shell || $route.fullPath)" />
      <loading />
    </main>

    <!-- AI 비서 (라우터 변경에 영향받지 않게 router-view 바깥) -->
    <AiAssistantButton v-if="showAiAssistant"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from "./components/common/Loading.vue"
import AiAssistantButton from "./components/ai/AiAssistantButton.vue"
import { ADMIN_TYPE, getAdminBranding } from './config/adminConfig'
import { ODIST_MENUS, odistItemVisibleFor, odistMenuItem, ODIST_LOGIN_PATH } from './config/odist-menus'
import { odistSubPerm, odistCanRead } from './utils/odistPerm'

export default {
  name: 'App',
  components: {
    Loading,
    AiAssistantButton
  },
  computed: {
    ...mapGetters({
      filter_list: 'filter_list',
      login_token: 'login_token',
      agency: 'agency',
      hide_menu: 'hide_menu',
      flutterWindows: 'flutterWindows',
      menu_title: 'menu_title',
      admin: 'admin',
      clr_info: 'clr_info',
      admin_type: 'admin_type',
      isAllowedMasterIp: 'isAllowedMasterIp',
      uid: 'uid',
      login_data: 'login_data',
      agency_sub_accounts: 'agency_sub_accounts',
      is_subuser: 'is_subuser',
      sub_permissions: 'sub_permissions'
    }),
    isMyshopAdmin() {
      return this.admin_type === ADMIN_TYPE.MYSHOP
    },
    currentBranding() {
      return getAdminBranding(this.admin_type)
    },
    // localhost 또는 개발 서버 여부 확인
    isLocalhost() {
      const hostname = window.location.hostname
      return hostname === 'localhost'
        || hostname === '127.0.0.1'
        || hostname.startsWith('admin') && hostname.endsWith('.shockping.com')
    },
    // MYSHOP 마스터 관리 메뉴 노출 조건 (admin 또는 uid 67이고 허용된 IP 또는 localhost)
    // 서브유저 메뉴 필터링: 허용된 경로인지 확인
    subuserAllowedPaths() {
      if (!this.is_subuser) return null
      if (!this.sub_permissions || !this.sub_permissions.allowed_paths) return []
      return this.sub_permissions.allowed_paths
    },
    canShowMasterMenu() {
      const isAdmin = this.admin || this.uid === 67 || (this.login_data && this.login_data.admin)
      return isAdmin && (this.isAllowedMasterIp || this.isLocalhost)
    },
    // AI 비서는 ext_parent_v2 가 노출되는 경로 (메뉴 상품/카테고리/옵션 통합 페이지) 에서만 띄운다.
    showAiAssistant() {
      const p = this.$route.path
      return p.indexOf('/admin/e_prod_list') >= 0 || p.indexOf('/ext/prod_list') >= 0
    },
    // 계정 전환 UI(현재 계정 표시 / 마스터 계정으로 전환 / 고객 계정 전환)는
    // ERP·ODIST 화면에서만 노출한다.
    showAccountSwitchArea() {
      const p = this.$route.path
      return p.indexOf('/erp') >= 0 || p.indexOf('/odist') >= 0
    },
    // ---------------- odist 직원(서브)계정 ----------------
    odistSub() {
      return !!odistSubPerm(this.$store)
    },
    // 사이드바용 odist 메뉴: 계정 종류(마스터/매장)로 거르고, 직원계정이면 역할이 조회 이상 준 것만
    odistMenuGroups() {
      const isMaster = !!this.agency
      const sub = odistSubPerm(this.$store)
      return ODIST_MENUS.map(g => ({
        key: g.key,
        title: g.title,
        items: g.items.filter(it => odistItemVisibleFor(odistMenuItem(it.key), isMaster) && (it.subOnly ? !!sub : true) && (!sub || odistCanRead(this.$store, it.key)))
      })).filter(g => g.items.length > 0)
    },
    odistScopeItems() {
      if (!this.odistScope) return []
      const items = []
      if (this.odistScope.master_allowed) {
        items.push({ uid: this.odistScope.master_uid, name: (this.odistScope.master_name || '마스터') + ' (마스터)' })
      }
      ;(this.odistScope.stores || []).forEach(st => items.push({ uid: st.uid, name: st.name }))
      return items
    },
    odistCurrentName() {
      const f = this.odistScopeItems.find(a => Number(a.uid) === Number(this.uid))
      const who = f ? f.name : ((this.login_data && this.login_data.name) || '')
      const role = this.sub_permissions && this.sub_permissions.role_name
      return role ? `${who} · ${role}` : who
    },
    currentAccountName() {
      if (!this.uid) return null
      if (this.odistSub) return this.odistCurrentName || null
      if (this.agency_sub_accounts && this.agency_sub_accounts.length > 0) {
        const found = this.agency_sub_accounts.find(a => a.uid === this.uid)
        if (found) return found.name
      }
      if (this.login_data && this.login_data.name) return this.login_data.name
      return null
    },
    // 서브계정 목록 맨 앞에 백엔드가 항상 넣어주는 "마스터 계정"(uid=에이전시 uid) 항목
    masterAccount() {
      return (this.agency_sub_accounts || []).find(a => a.name === '마스터 계정') || null
    },
    // 마스터에서 매장으로 전환된 상태(현재 계정이 마스터가 아님) 여부
    isSwitchedToStore() {
      const m = this.masterAccount
      return !!(m && this.uid && Number(this.uid) !== Number(m.uid))
    },
    itemListPath() {
      return (this.agency || this.canShowMasterMenu) ? '/admin/erp/item_list' : '/admin/erp/item_list_shop'
    }
  },
  watch: {
    clr_info() {
      this.check_color()
    },
    admin_type() {
      this.check_color()
    },
    canShowMasterMenu: {
      handler(newVal) {
        if (newVal) {
          this.init_agency()
        }
      },
      immediate: true
    },
    is_subuser(v) {
      if (v) this.loadOdistScope()
    },
    agency: {
      handler(newVal) {
        if (newVal) {
          this.init_agency()
        }
      },
      immediate: true
    },
    admin: {
      handler() {
        // admin 값이 변경되면 마스터 IP 체크 수행
        this.checkMasterIpAccess()
      },
      immediate: true
    },
    uid: {
      handler(newVal) {
        // uid가 67로 설정되면 마스터 IP 체크 수행
        if (newVal === 67) {
          this.checkMasterIpAccess()
        }
        
        // 현재 UID로 선택된 서브 계정 초기화
        if (newVal) {
          this.selected_sub_account = newVal
        }
      },
      immediate: true
    },
    login_data: {
      handler(newVal) {
        // 로그인 데이터가 로드되면 마스터 IP 체크 및 에이전시 권한 확인 수행
        if (newVal) {
          if (newVal.admin || newVal.uid === 67) {
            this.checkMasterIpAccess()
          }
          this.init_agency()
          // 로그인 확인(userinfo) 전에 메뉴 확인이 먼저 돌아 실패했을 수 있다 — 로그인 정보가 오면 한 번 더
          if (this.menu_type === 10 && !this.myshopFeat.partner && !this.myshopFeat.social && !this.myshopFeat.youtube) this.loadMyshopFeatures()
        }
      },
      immediate: true
    },
    drawer(val) {
      // drawer가 열릴 때 MYSHOP 관리자면 order summary 새로고침
      if (val && this.menu_type === 10) {
        this.loadOrderSummary()
        if (this.myshopFeat.partner) this.loadPartnerPending()
      }
    },
    '$route.path'(newPath) {
      // 메뉴 아이템 클릭 시 drawer 닫기
      this.drawer = false

      // iframe 내에서 라우트 변경 시 부모에게 알림 (url_path 동기화)
      if (window.self !== window.top) {
        const query = Object.assign({}, this.$route.query)
        delete query.token
        window.parent.postMessage({ type: 'iframe-nav', path: newPath, query: query }, '*')
      }

      let loc = newPath
      // MYSHOP 관리자 페이지 (/myshop/ 경로로 시작하는 경우만, /admin/myshop_info 같은 QRO 페이지는 제외)
      if (loc.startsWith('/myshop') || loc.startsWith('/myshop/')) {
        if (this.menu_type !== 10) {
          this.menu_type = 10  // MYSHOP 메뉴 타입
          this.loadOrderSummary()
          this.loadMyshopFeatures()
        }
      }
      // QRO 관리자 페이지
      else if (loc.indexOf("/odist") >= 0) {
        this.menu_type = 6
      } else if (loc.indexOf("/erp") >= 0) {
        this.menu_type = 2
      } else if (loc.indexOf("/riders") >= 0) {
        this.menu_type = 4
      } else if (loc.indexOf("/rider-user") >= 0) {
        this.menu_type = 5
      } else {
        this.menu_type = 0
      }

      if (loc.indexOf("/sales_report") >= 0 && loc.indexOf("/odist") < 0) {
        // /admin/sales_report/* 경로는 항상 menu_type 0 (기본 admin 메뉴) 유지.
        // 단 /admin/odist/sales_report/* 는 odist 메뉴(6)를 그대로 둔다 —
        // 여기서 0으로 덮으면 매장 담당자가 리포트를 열자마자 odist 메뉴를 잃는다.
        this.menu_type = 0
      }

      // 마스터 관리 경로로 이동 시 IP 체크 재수행
      this.checkMasterIpAccess()
    }
  },
  data() {
    return {
      menu_type: 0,
      hide_drawer: false,
      color: '#2563EB',
      drawer: false,
      menu: false,
      orderSummary: {},
      // MYSHOP 메뉴 중 백엔드가 있어야 보이는 묶음 — 확인 전·실패면 숨김(loadMyshopFeatures)
      myshopFeat: { partner: false, partnerPending: 0, social: false, youtube: false },
      myshopFeatLoading: false,
      myshopFeatAgain: false,
      routeKey: 0,
      selected_sub_account: null,
      accountSwitching: false,
      // odist 직원계정 전환 범위 (/core-api/subuser/odist/scope)
      odistScope: null,
      selected_odist_account: null
    }
  },
  created() {
    let userAgent = navigator.userAgent
    let b = this.isMobile(userAgent)
    this.$store.commit('mobile', b)

    if (userAgent.indexOf('flutter-windows') >= 0) {
      this.$store.commit('flutterWindows', true)
      this.appendFile()
    }

    const turl = new URL(location.href)
    if (turl.searchParams.get('sid') && turl.searchParams.get('skey')) {
      this.$cookie.setCookie3('sid', turl.searchParams.get('sid'))
      this.$cookie.setCookie3('skey', turl.searchParams.get('skey'))
    }
  },
  mounted() {
    let loc = location.pathname || location.href
    // MYSHOP 관리자 페이지 (/myshop 경로로 시작하는 경우만, /admin/myshop_info 같은 QRO 페이지는 제외)
    if (loc.startsWith('/myshop') || loc.indexOf('/myshop/') === 0) {
      this.menu_type = 10
      this.loadOrderSummary()
      this.loadMyshopFeatures()
    } else if (loc.indexOf("/odist") >= 0) {
      this.menu_type = 6
    } else if (loc.indexOf("/erp") >= 0) {
      this.menu_type = 2
    }

    this.check_color()
    this.checkMasterIpAccess()
    this.init_agency()

    const turl = new URL(location.href)
    if (turl.searchParams.get('menu')) {
      this.$cookie.setCookie2('admin_menu', '1')
    }

    if (this.$cookie.getCookie2('admin_menu')) {
      this.menu = true
    }

    if (window.self !== window.top) {
      this.menu = false
      if (turl.searchParams.get('token')) {
        this.menu = true
      }
    } else {
      this.menu = true
    }

    let path = this.$route.path
    if (path === '/') path = location.href

    if (path.indexOf('/login') >= 0 || path.indexOf('/embed') >= 0 || path.indexOf('/_embed') >= 0 || path.indexOf('/ext') >= 0 || path.indexOf('/e_mod') >= 0) {
      this.hide_drawer = true
    }
  },
  methods: {
    async checkMasterIpAccess() {
      // admin 권한이 있거나 uid가 67이거나 login_data.admin인 경우에만 IP 체크 수행
      const isAdmin = this.admin || this.uid === 67 || (this.login_data && this.login_data.admin)
      if (!isAdmin) {
        return
      }

      // localhost인 경우 바로 허용
      if (this.isLocalhost) {
        this.$store.commit('isAllowedMasterIp', true)
        return
      }
      // 서버에서 IP 허용 여부 확인 (허용 IP: 15.164.121.204, 107.191.60.123, localhost)
      try {
        await this.$http.get('/core-api/user/admin_checking')
        // 성공 시 허용된 IP
        this.$store.commit('isAllowedMasterIp', true)
      } catch (err) {
        // 실패 시 (not_valid 예외) 허용되지 않은 IP
        this.$store.commit('isAllowedMasterIp', false)
      }
    },
    async loadOrderSummary() {
      try {
        const { data } = await this.$http.get('/api/shopadm/get/order/summary')
        this.orderSummary = data || {}
      } catch (err) {
        console.warn('Failed to load order summary:', err)
      }
    },
    // 파트너 판매·SNS 판매 자동화 메뉴를 보일지 — 그 API 가 아직 없거나(배포 전) 꺼져 있으면 묶음을 숨긴다(c35b3424 해외 배송 블록과 같은 방식).
    // 파트너: Java GET /api/shopadm/partner/program 이 {available:true} 를 줄 때. SNS: core-api 인스타 상태가 켜짐·시범 샵일 때
    async loadMyshopFeatures() {
      // 확인 중에 또 불리면(로그인 정보가 막 들어온 때 등) 끝난 뒤 한 번 더
      if (this.myshopFeatLoading) { this.myshopFeatAgain = true; return }
      this.myshopFeatLoading = true
      this.myshopFeatAgain = false
      const partner = this.$http.get('/api/shopadm/partner/program')
        .then(({ data }) => {
          this.myshopFeat.partner = !!(data && data.available)
          if (this.myshopFeat.partner && data.program && data.program.enabled) this.loadPartnerPending()
        })
        .catch(() => { this.myshopFeat.partner = false })
      const social = this.$http.get('/core-api/social/instagram/status')
        .then(({ data }) => { this.myshopFeat.social = !!(data && data.enabled && data.allowed) })
        .catch(() => { this.myshopFeat.social = false })
      const youtube = this.$http.get('/core-api/social/youtube/status')
        .then(({ data }) => { this.myshopFeat.youtube = !!(data && data.enabled && data.allowed) })
        .catch(() => { this.myshopFeat.youtube = false })
      await Promise.all([partner, social, youtube])
      this.myshopFeatLoading = false
      if (this.myshopFeatAgain && !this.myshopFeat.partner && !this.myshopFeat.social && !this.myshopFeat.youtube) this.loadMyshopFeatures()
    },
    // 승인 대기 파트너 수(메뉴 배지)
    async loadPartnerPending() {
      try {
        const { data } = await this.$http.get('/api/shopadm/partner/list', { params: { status: 'PENDING', page: 0, size: 1 } })
        this.myshopFeat.partnerPending = (data && data.total) || 0
      } catch (e) {
        this.myshopFeat.partnerPending = 0
      }
    },
    async openMyshop() {
      try {
        const { data } = await this.$http.get('/api/shopadm/get/myinfo')
        if (data && data.shopid) {
          window.open(`https://${data.shopid}.mshp.in`, '_blank')
        } else {
          this.$toast.error('마이샵 정보를 불러올 수 없습니다.')
        }
      } catch (err) {
        this.$toast.error('마이샵 정보를 불러올 수 없습니다.')
      }
    },
    logout() {
      const logoutUrl = "https://core-api-v2.shockping.com/core-api/auth/logout"

      // odist 는 로그아웃 후 다시 odist 로 돌아오게 복귀 주소를 넘긴다.
      // url 을 안 넘기면 core-api 가 insight.shockping.com 으로 보내버림.
      if (this.menu_type === 6 || (location.pathname || '').indexOf('/odist') >= 0) {
        const adminUrl = process.env.VUE_APP_ADMIN_URL || 'https://admin2.shockping.com'
        // odist 로그인으로 돌아간다 — 마스터·매장·직원 모두(2026-10-29 로그인 화면 하나로 합침. 예전엔 마스터는 MYSHOP 로그인)
        const back = adminUrl + ODIST_LOGIN_PATH
        location.href = logoutUrl + '?url=' + encodeURIComponent(back)
        return
      }

      location.href = logoutUrl
    },
    go_ja0() {
      location.href = 'https://ja0.com'
    },
    check_color() {
      // MYSHOP 관리자는 고유 색상 사용
      if (this.admin_type === ADMIN_TYPE.MYSHOP) {
        this.color = this.currentBranding.primaryColor
        return
      }
      // QRO 관리자는 설정된 색상 또는 기본 색상 사용
      if (this.clr_info && this.clr_info["--qro-primary-color"]) {
        this.color = this.clr_info["--qro-primary-color"]
      } else {
        this.color = '#2563EB'
      }
    },
    otherWheel(e) {
      if (this.flutterWindows) {
        let y = e.deltaY
        let timeStamp = e.timeStamp
        this.$store.commit('wheelDelta', { y, timeStamp })
      }
    },
    isMobile(UserAgent) {
      if (UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null) {
        return true
      }
      return false
    },
    isSubuserAllowed(path) {
      if (!this.subuserAllowedPaths) return true
      const fullPath = path.startsWith('/') ? path : '/admin/erp/' + path
      return this.subuserAllowedPaths.some(p => fullPath === p || fullPath.startsWith(p + '/'))
    },
    isSubuserGroupAllowed(paths) {
      if (!this.subuserAllowedPaths) return true
      return paths.some(p => this.isSubuserAllowed(p))
    },
    // 현재 라우트와 메뉴 항목의 경로/쿼리가 일치하는지 확인해 사이드바에서 활성 표시.
    // master / type 쿼리는 같은 경로의 항목을 구분하는 용도라 별도로 대조한다.
    isActive(path, query) {
      if (!path || this.$route.path !== path) return false
      // 구분용 쿼리 키만 비교 (token, page 등 부수적인 쿼리는 무시)
      const distinguishingKeys = ['master', 'type']
      if (query) {
        return distinguishingKeys.every(k => {
          if (k in query) {
            return String(this.$route.query[k] ?? '') === String(query[k])
          }
          return true
        })
      }
      // 쿼리가 없는 항목은, 같은 경로의 쿼리 변형 항목이 활성일 때는 비활성으로 둔다.
      return !distinguishingKeys.some(k => !!this.$route.query[k])
    },
    nav(routeObj) {
      const resolved = this.$router.resolve(routeObj)

      // 현재 /ext/erp 경로인 경우, url_path 파라미터로 경로 동기화
      if (this.$route.path === '/ext/erp') {
        // 상대경로인 경우 /admin/erp/ 기준으로 변환 (resolve가 /ext/ 기준으로 잘못 해석하므로)
        let targetPath = resolved.path
        if (routeObj.path && !routeObj.path.startsWith('/')) {
          targetPath = '/admin/erp/' + routeObj.path
        }
        const targetQuery = resolved.query || {}
        const newQuery = { token: this.$route.query.token || this.login_token, url_path: targetPath }
        // 대상 경로의 query 파라미터를 병합 (token, url_path 제외)
        Object.keys(targetQuery).forEach(k => {
          if (k !== 'token' && k !== 'url_path') newQuery[k] = targetQuery[k]
        })
        if (JSON.stringify(this.$route.query) === JSON.stringify(newQuery)) {
          this.routeKey++
        } else {
          this.$router.push({ path: '/ext/erp', query: newQuery })
        }
        this.drawer = false
        return
      }

      // login_token이 있으면 query에 token 포함하여 이동
      if (this.login_token) {
        const query = Object.assign({}, resolved.query || {}, routeObj.query || {})
        if (!query.token) {
          query.token = this.login_token
        }
        const finalRoute = { path: resolved.path, query }
        const currentQuery = Object.assign({}, this.$route.query)
        if (this.$route.path === resolved.path && JSON.stringify(currentQuery) === JSON.stringify(query)) {
          this.routeKey++
        } else {
          this.$router.push(finalRoute)
        }
      } else {
        if (this.$route.path === resolved.path && JSON.stringify(this.$route.query) === JSON.stringify(resolved.query || {})) {
          this.routeKey++
        } else {
          this.$router.push(routeObj)
        }
      }
      this.drawer = false
    },
    appendFile() {
      let file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = '/css/flutter.css'
      document.head.appendChild(file)
    },
    async loadOdistScope() {
      if (!this.odistSub) return
      try {
        const { data } = await this.$http.get('/core-api/subuser/odist/scope')
        this.odistScope = data
        this.selected_odist_account = this.uid
      } catch (e) {
        this.odistScope = null
      }
    },
    async odistSwitch(uid) {
      if (!uid || Number(uid) === Number(this.uid)) return
      this.accountSwitching = true
      try {
        await this.$http.post(`/core-api/subuser/odist/switch?uid=${uid}`)
        // 진입 페이지가 계정 종류·역할에 맞는 첫 화면으로 보낸다
        location.href = '/admin/odist'
      } catch (e) {
        this.accountSwitching = false
        this.selected_odist_account = this.uid
        this.$eventBus.$emit('alert', '계정 전환에 실패했습니다. 다시 로그인해주세요.')
      }
    },
    init_agency() {
      // odist 직원계정은 daemon 의 에이전시 전환을 쓰지 않는다 (서브 마커가 유실됨). 자체 스위처를 쓴다.
      if (this.odistSub) return
      // 에이전시/마스터 권한이 있거나, 에이전시 쿠키(마스터→매장 전환된 상태)가 있으면 서브 계정 목록 로드.
      // 전환된 매장 계정은 agency=false 라 쿠키까지 봐야 "마스터 계정" 포함 목록을 다시 불러올 수 있다.
      const a1 = this.$cookie.getCookie2('agency_sid')
      const a2 = this.$cookie.getCookie2('agency_skey')
      if (this.agency || this.canShowMasterMenu || (a1 && a2)) {
        this.check_agency()
      }
    },
    async check_agency() {
      // agency_sid/agency_skey 쿠키로 에이전시 모드 확인
      const a1 = this.$cookie.getCookie2('agency_sid')
      const a2 = this.$cookie.getCookie2('agency_skey')

      // 에이전시 쿠키가 있거나 agency 상태가 true일 때 서브 계정 목록 로드
      if (this.agency || (a1 && a2)) {
        this.loadSubAccounts()
      }
    },
    async loadSubAccounts() {
      // agency_sid/agency_skey 쿠키를 사용하여 서브 계정 목록 로드
      const a1 = this.$cookie.getCookie2('agency_sid')
      const a2 = this.$cookie.getCookie2('agency_skey')

      if (!a1 || !a2) {
        // 쿠키가 없으면 스토어 상태 초기화
        this.$store.commit('agency_sub_accounts', [])
        return
      }

      try {
        const { data } = await this.$http.get(`/api/shopadm/get/sub_accounts/of_agency/v2?sid=${a1}&skey=${a2}`)
        if (data && Array.isArray(data) && data.length > 0) {
          this.$store.commit('agency_sub_accounts', data)
          // 메뉴 분기용 agency 는 "현재 계정이 실제 마스터(에이전시 uid)인지"만 반영한다.
          // 전환된 매장 계정은 false 유지 → 매장 메뉴 노출. 계정 스위처/마스터복귀 버튼은
          // agency_sub_accounts(목록 로드 여부)로 별도 제어하므로 여기서 true 로 강제하지 않는다.
          const masterEntry = data.find(a => a.name === '마스터 계정')
          if (masterEntry && this.uid) {
            this.$store.commit('agency', Number(this.uid) === Number(masterEntry.uid))
          }
          // 현재 접속 중인 계정 UID를 선택 상태로 설정
          if (this.uid) {
            this.selected_sub_account = this.uid
          }
        } else {
          // data가 없거나 배열이 비어있으면 agency 권한이 없거나 세션이 만료된 것으로 간주
          this.$store.commit('agency', false)
          this.$cookie.delete_cookie('agency_sid', '/')
          this.$cookie.delete_cookie('agency_skey', '/')
          this.$store.commit('agency_sub_accounts', [])
        }
      } catch (err) {
        console.warn('Failed to load sub-accounts:', err)
        // 에러 발생 시 (401 등) agency 권한 해제 및 쿠키 삭제
        this.$store.commit('agency', false)
        this.$cookie.delete_cookie('agency_sid', '/')
        this.$cookie.delete_cookie('agency_skey', '/')
        this.$store.commit('agency_sub_accounts', [])
      }
    },
    async chg_sub_accounts(uid) {
      if (!uid) return
      if (uid === this.uid) {
        this.$eventBus.$emit('info', '현재 접속 중인 계정입니다.')
        return
      }

      const a1 = this.$cookie.getCookie2('agency_sid')
      const a2 = this.$cookie.getCookie2('agency_skey')

      if (!a1 || !a2) {
        this.$eventBus.$emit('alert', '계정 전환 권한이 없습니다. 다시 로그인해주세요.')
        return
      }

      this.accountSwitching = true
      try {
        await this.$http.get(`/api/shopadm/change_to/sub_accounts/of_agency?sid=${a1}&skey=${a2}&uid=${uid}`)
        const isMaster = this.masterAccount && Number(uid) === Number(this.masterAccount.uid)
        const isErpContext = location.pathname.includes('/erp/')
        const masterLanding = isErpContext ? '/admin/erp/master' : '/admin/odist/vendor_management'
        if (isMaster) {
          location.href = masterLanding
        } else if (isErpContext) {
          location.href = location.href.split('?')[0]
        } else {
          // odist 매장 계정으로 전환 시 매장 첫 화면으로. 경로를 직접 박지 않고 진입 페이지를 거친다
          // (매장 첫 화면은 odist_home.vue 의 STORE_HOME 한 곳에서만 관리)
          location.href = '/admin/odist'
        }
      } catch (err) {
        this.accountSwitching = false
        this.selected_sub_account = this.uid
        this.$eventBus.$emit('alert', '계정 전환에 실패했습니다. 다시 로그인해주세요.')
        console.error('Failed to switch sub-account:', err)
      }
    },
    // 전환된 매장 계정에서 마스터(에이전시) 계정으로 복귀. 로그인 화면을 거치지 않고
    // 보존된 에이전시 쿠키로 바로 마스터 세션을 복원한 뒤 마스터 설정 페이지로 이동한다.
    async backToMaster() {
      const m = this.masterAccount
      if (!m) return

      const a1 = this.$cookie.getCookie2('agency_sid')
      const a2 = this.$cookie.getCookie2('agency_skey')
      if (!a1 || !a2) {
        this.$eventBus.$emit('alert', '마스터 계정 정보가 없습니다. 다시 로그인해주세요.')
        return
      }

      this.accountSwitching = true
      try {
        await this.$http.get(`/api/shopadm/change_to/sub_accounts/of_agency?sid=${a1}&skey=${a2}&uid=${m.uid}`)
        const isErpContext = location.pathname.includes('/erp/')
        location.href = isErpContext ? '/admin/erp/master' : '/admin/odist/vendor_management'
      } catch (err) {
        this.accountSwitching = false
        this.$eventBus.$emit('alert', '마스터 계정 전환에 실패했습니다. 다시 로그인해주세요.')
        console.error('Failed to switch back to master:', err)
      }
    }
  }
}
</script>

<style>
/* odist 직원계정: 매입단가·원가 숨김 (역할 옵션 show_purchase_price=false). 화면은 원가 칸에 .cost-col 만 붙인다 */
.odist-hide-cost .cost-col { display: none !important; }

html {
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

body {
  -webkit-overflow-scrolling: touch;
  margin: 0;
  padding: 0;
  overflow: hidden !important;
}

/* 🔑휴대폰은 100vh = 주소창이 접힌 높이 — html/body 스크롤을 막아 주소창이 안 접히니 그만큼 화면 아래가 가려져
   끝까지 스크롤이 안 됐다(2026-10-20 판매 리포트) → 보이는 높이(dvh). dvh 모르는 브라우저는 앞 줄 */
.app-layout {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #F9FAFB;
}

.app-main {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.pos_body {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Drawer Header Styles */
.drawer-header-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.drawer-brand-logo {
  display: block;
  height: 26px;
  width: auto;
  margin: 3px 0;
}

.drawer-logo {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}

.drawer-title-area {
  flex: 1;
}

.drawer-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: white;
}

.drawer-subtitle {
  display: none;
}

.app-bar-right-area {
  display: flex;
  align-items: center;
  gap: 10px;
}

.app-bar-account-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 앱바 헤더는 backdrop-filter 때문에 z-index:auto stacking context 를 만든다.
   그 안에 갇힌 계정전환 드롭다운이 본문(.app-main)의 positioned 요소(예: 테이블 sticky thead z-index:2)에
   가려지던 문제 → 헤더 자체를 콘텐츠 위 stacking 으로 끌어올린다. (모달 backdrop 1050 보다는 아래) */
.app-bar {
  position: relative;
  z-index: 1030;
}

.app-bar-master-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255, 255, 255, 0.92);
  color: #4338ca;
  border: 1px solid rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 6px;
  white-space: nowrap;
  cursor: pointer;
}
.app-bar-master-btn:hover { background: #fff; }
.app-bar-master-btn:disabled { opacity: 0.6; cursor: default; }

.app-bar-account-switch {
  width: 250px;
  margin-right: 12px;
  position: relative;
  z-index: 100;
}

.app-bar-account-switch .base-autocomplete__dropdown {
  z-index: 9999 !important;
}

.account-switch-select .base-autocomplete__input {
  background-color: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  height: 36px;
  padding-top: 0;
  padding-bottom: 0;
}

.account-switch-select .base-autocomplete__input::placeholder {
  color: rgba(255, 255, 255, 0.6) !important;
}

.account-switch-select .base-autocomplete__input:focus {
  background-color: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.15) !important;
}

.account-switch-select .base-autocomplete__dropdown {
  color: #374151 !important;
  background: white !important;
  border-radius: 8px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.account-switch-select .base-autocomplete__item {
  padding: 10px 14px;
  color: #374151 !important;
}

.account-switch-select .base-autocomplete__item:hover,
.account-switch-select .base-autocomplete__item.is-highlighted {
  background-color: #EEF2FF !important;
  color: #4F46E5 !important;
}
</style>
